import React, { forwardRef } from 'react';
import styled from 'styled-components';

const LineGraphHeader = styled.header`
    padding: 10px;
    text-align: center;
    display: flex !important;
    flex-direction: row;
    flex-wrap: wrap;
`;
const LineGraphTitle = styled.span<{ fontSize: number }>`
    font-size: ${(props) => props.fontSize}%;
    line-height: 1.5;
    padding-right: 0.5em;
    font-weight: bold;
`;
const LineGraphSubtitle = styled.span<{ fontSize: number }>`
    font-size: ${(props) => props.fontSize}%;
    line-height: 1.5;
    padding-bottom: 8px;
`;

interface IProps {
    id?: string;
    title: string;
    subTitle: string;
    fontSize: number;
}

const Header = forwardRef(({ title, subTitle, id, fontSize }: IProps, ref: React.Ref<HTMLDivElement>) => {
    return (
        <LineGraphHeader id={id} ref={ref}>
            <LineGraphTitle fontSize={fontSize}>{title}</LineGraphTitle>
            <LineGraphSubtitle fontSize={fontSize}>{subTitle}</LineGraphSubtitle>
        </LineGraphHeader>
    );
});

export default Header;
